import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../styles/login.css";
import axios from "axios";

import { loginReducer, sidebarReducer } from "../../Redux/store";
import { AccessTockenReducer } from "../../Redux/store";
// import { loginRequest } from "../../Office365/authConfig";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import backgroundImg from "../../images/JioBPLogin.png";
// import TextField from "@material-ui/core/textfield";
import { InputAdornment, IconButton } from "@mui/material";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,

} from "@azure/msal-react";
import Dashbord from "./dashbord";

function Userlogin() {
  // const { instance } = useMsal();
  const dispatch = useDispatch();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loginFail, setLoginFail] = useState(false);
  const [notAuth, setNotAuth] = useState(false);
  // const [apiLoad, setApiLaod] = useState(false);
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);

  // Add these variables to your component to track the stateconst [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleSubmit = async (e) => {
    //Main login function
    e.preventDefault();
    dispatch(sidebarReducer.apiLoad(true));
    // setApiLaod(true);
    dispatch(AccessTockenReducer.userType("platform"));

    await axios
      .post(
        "auth/login",
        // "loginauth/userlogin",
        JSON.stringify({ username: userName, password: password }),
        {
          headers: { "content-type": "application/json" },
        }
      )
      .then((response) => {
        if (response.data.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          // setApiLaod(false);
          if (
            response.data.message === "User not found" ||
            response.data.message === "Incorrect Password"
          ) {
            setLoginFail(true);
          } else if (
            response.data.message === "You are not authorized to access!"
          ) {
            // console.log(notAuth, "notauth");
            setNotAuth(true);
          } else {
            setLoginFail(false);
            const accessTKN = response.data.data.user_details.access_token;
            const refreshTKN = response.data.data.user_details.refresh_token;
            const tempPassword = response.data.data.user_details.te_is_temp_pwd;
            const tokenExpiry = response.data.data.user_details.tokenExpiresAt;
            const loginUserId = response.data.data.user_details.te_userid;
            const user_Name = response.data.data.user_details.te_username;
            const permissions = response.data.data.permissions.modules;
            const listLimit = Number(
              response.data.Settings[1].te_settings_value
            );

            dispatch(loginReducer.Login());
            dispatch(loginReducer.Temp_password(tempPassword));
            dispatch(loginReducer.Login_UserId(loginUserId));
            dispatch(AccessTockenReducer.accessTocken(accessTKN));
            dispatch(AccessTockenReducer.recordsPerPage(listLimit));
            dispatch(AccessTockenReducer.refreshTocken(refreshTKN));
            dispatch(AccessTockenReducer.timeOut(tokenExpiry));
            dispatch(loginReducer.Login_UserName(user_Name));
            dispatch(sidebarReducer.stringUpdate("DashBoard"));
            // The data in the local storage is used when the page is reloaded , if the page is logged in while relaoding the page will be still logged in if the page is not logged in the page will show the UserLogin.jsx
            sessionStorage.setItem("isLogin", true);
            sessionStorage.setItem("permission", JSON.stringify(permissions));
            let localdata = response.data;
            // console.log(localdata);
            sessionStorage.setItem("userdata", JSON.stringify(localdata));
            sessionStorage.setItem("access_token", accessTKN);
            sessionStorage.setItem("refresh_token", refreshTKN);
            sessionStorage.setItem("timeOut", tokenExpiry);
            sessionStorage.setItem("navigate", "DashBoard");
          }
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        // setApiLaod(false);
      });
  };

  // const tempLogin = () => {
  //Temp Login function
  //dispatch(loginReducer.Login());
  // };

  // office 365 login
  // const handleLogin = () => {
  //   console.log("clicking")
  //   dispatch(AccessTockenReducer.userType("O365"));
  //   instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  // };

  // const IconTextField = ({ iconStart, iconEnd, InputProps, ...props }) => {
  //   return (
  //     <TextField
  //       {...props}
  //       InputProps={{
  //         ...InputProps,
  //         startAdornment: iconStart ? (
  //           <InputAdornment position="start">{iconStart}</InputAdornment>
  //         ) : null,
  //         endAdornment: iconEnd ? (
  //           <InputAdornment position="end">{iconEnd}</InputAdornment>
  //         ) : null,
  //       }}
  //     />
  //   );
  // };
  return (
    <>
      <AuthenticatedTemplate>
        <Dashbord />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <div
          className="container-fluid g-0 m-0 p-0 background-image"
          style={{
            backgroundImage: `url(${backgroundImg})`,
            transition: 'opacity 0.3s ease-in',
          }}
        >
          <div className="row ">
            <div
              className="col-lg-6 col-md-6 text-center col-sm-12"
              style={{ height: "100vh" }}
            >
              <div className="form-background" >
                <form onSubmit={handleSubmit}>
                  <h4>
                    Welcome Back!
                  </h4>
                  <h3>
                    Sign in to Continue
                  </h3>
                  {loginFail && (
                    <p className="p-0 m-0 text-danger">
                      Invalid username or password
                    </p>
                  )}
                  {notAuth && (
                    <p className="p-0 m-0 text-danger">
                      You are not authorzied to access!
                    </p>
                  )}

                  <Box
                    //component="form"
                    sx={{
                      "& > :not(style)": { m: 1, width: "36ch" },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      id="UserName"
                      label="UserName"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      maxLength={"15"}
                      value={userName}
                      onChange={(e) => {
                        const { value } = e.target;
                        setUserName(value);
                        setLoginFail(false);
                        setNotAuth(false);
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'black', 
                          },
                          '&:hover fieldset': {
                            borderColor: '#009900', 
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#009900',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          color: 'black', 
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          color: '#009900', 
                        },
                        '&:hover .MuiInputLabel-root': {
                          color: '#009900', 
                        },
                      }}
                    />

                    <br></br>

                    <TextField
                      label="Password"
                      variant="outlined"
                      autoComplete="off"
                       inputProps={{
                        autoComplete: "new-password",
                      }}
                      InputLabelProps={{ shrink: true }}
                      minLength="8"
                      maxLength="20"
                      value={password}
                      onChange={(e) => {
                        const { value } = e.target;
                        setPassword(value);
                        setLoginFail(false);
                        setNotAuth(false);
                      }}

                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'black', 
                          },
                          '&:hover fieldset': {
                            borderColor: '#009900', 
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#009900',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          color: 'black', 
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          color: '#009900', 
                        },
                        '&:hover .MuiInputLabel-root': {
                          color: '#009900', 
                        },
                        "& .MuiOutlinedInput-input::-ms-reveal": {
                          display: "none",
                        },
                      }}
                      type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                      // onChange={someChangeHandler}
                      InputProps={{
                        // <-- This is where the toggle button is added.
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>

                  <button className="signinbtn" type="submit">
                    Sign in
                  </button>
                  <br></br>
                  {/* <div className="d-flex justify-content-center">
                    <div
                      className="forgotpassword"
                      onClick={() => {
                        dispatch(loginReducer.Forget_password(true));
                      }}
                    >
                      Forgot Password?
                    </div>
                  </div> */}
                </form>
              </div>

         
            </div>
            {/* <div className="col-lg-6 col-md-6 col-sm-12">
              <img
                className="Logo"
                width="100%"
                height="100%"
                src={require("../../images/CMSBranding.png")}
                alt="TATA Elxsi"
              ></img>
            </div> */}
          </div>
        </div>
        <div className="backdrop">
          <Backdrop
            sx={{
              color: "var(--themes-color)",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={apiLoad}
          //onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </div>
      </UnauthenticatedTemplate>
    </>
  );
}
export default Userlogin;
